import React from 'react';
import GameOver from '../components/GameOver';
import { QuizSettings } from '../types/quiz';

interface GameOverPageProps {
  score: number;
  totalQuestions: number;
  onRestart: () => void;
  settings: QuizSettings;
}

const GameOverPage: React.FC<GameOverPageProps> = ({ score, totalQuestions, onRestart, settings }) => {
  return (
    <GameOver 
      score={score} 
      totalQuestions={totalQuestions} 
      onRestart={onRestart}
      settings={settings} 
    />
  );
};

export default GameOverPage;
